import './index.less'


// WEBPACK FOOTER //
// ./ecology9/wea-table-edit/style/index.js